import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import parseDate from './parseDate'

export const getUTCDate = (dateString = Date.now(), min, max) => {
  const date = new Date(dateString);
  // 1529013600000 # bern
  // 1529029800000 # st johns
  const dateUtc = new Date(
    date.getUTCFullYear(),
    // date.getUTCMonth(), // TODO edgecase where UTC month different from date month
    date.getUTCMonth(),
    // max ? date.getUTCDate() + 1 : date.getUTCDate(),
    max ? date.getUTCDate() + 1 : date.getUTCDate(),
    (min || max) ? 0 : date.getUTCHours(),
    (min || max) ? 0 : date.getUTCMinutes(),
    (min || max) ? 0 : date.getUTCSeconds(),
    (min || max) ? 0 : date.getUTCMilliseconds(),
  )

  return dateUtc
}

const debug = date => {
  console.log(date)
}

export const getDateFromTimeIso = timeIsoUnsafe => {  
  const timeIso = parseDate(timeIsoUnsafe)
  if (!timeIso || typeof(timeIso.getMonth) !== 'function') {
    return null
  }
  // console.log({ timeIsoUnsafe })
  // console.log({ timeIso })
  // console.log({ utcDate: getUTCDate(timeIso) })
  try {
    const utcDate = getUTCDate(timeIso)
    
    // const date = typeof(utcDate) === 'string' ? parseISO(utcDate) : utcDate
    const date = utcDate
    
    return format(parseDate(date), 'yyyy-MM-dd')
  } catch(error) {
    console.warn(error)
    return null
  }
}

export const getMinMaxDateFromTimeIso = ({ timeIso, min, max }) => {
  if (timeIso === '') {
    return null
  }
  try {
    const date = getUTCDate(timeIso, min, max)

    return date.toISOString()
  } catch(error) {
    console.warn(error)

    return null
  }
}

export default getDateFromTimeIso



// WEBPACK FOOTER //
// ./src/utility/getDateFromTimeIso.js